import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DeviceDetectorService } from '@core/services';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@environment/environment';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'x-warehouse',
  imports: [AsyncPipe, NgClass, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './warehouse.component.html',
})
export class WarehouseComponent {
  readonly deviceService = inject(DeviceDetectorService);
  private readonly domSanitizer = inject(DomSanitizer);

  readonly warehouseIframeSrc: SafeResourceUrl =
    this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${environment.warehouseIframeUrl}`,
    );
}
